import { render, staticRenderFns } from "./rujilu.vue?vue&type=template&id=b60643bc&scoped=true&"
import script from "./rujilu.vue?vue&type=script&lang=js&"
export * from "./rujilu.vue?vue&type=script&lang=js&"
import style0 from "./rujilu.vue?vue&type=style&index=0&id=b60643bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60643bc",
  null
  
)

export default component.exports